import { render, staticRenderFns } from "./v-footer.vue?vue&type=template&id=2ddc96a5&scoped=true"
import script from "./v-footer.vue?vue&type=script&lang=js"
export * from "./v-footer.vue?vue&type=script&lang=js"
import style0 from "./v-footer.vue?vue&type=style&index=0&id=2ddc96a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc96a5",
  null
  
)

export default component.exports